import { format, parse, subDays } from 'date-fns'
import { padZero } from './number'

/**
 * 日付をフォーマットします
 *
 * @param {date|string} date 日付
 * @param {string=YYYY-MM-DD} pattern フォーマットパターン
 */
export function formatDate(date, pattern = 'YYYY-MM-DD') {
  return format(date, pattern)
}

/**
 * 30時制などの変則時制の日時に変換します
 *
 * @param {(string|Date)} date 変換する Date
 * @param {number} [clock=30] 時制
 * @return {object} 変換後の日付 YYYY-MM-DD と時間 hh:mm
 */
export function toHourClock(date, clock = 30) {
  date = parse(date)
  const is24Over = date.getHours() < clock - 24
  date = is24Over ? subDays(date, 1) : date
  const hour = date.getHours() + (is24Over ? 24 : 0)
  const minute = date.getMinutes()
  return {
    date: formatDate(date),
    time: `${padZero(hour)}:${padZero(minute)}`,
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
    hour,
    minute,
  }
}

/**
 * 本日の日付を返します
 *
 * @return {string} 本日の日付 YYYY-MM-DD
 */
export function today() {
  return toHourClock(new Date()).date
}
